import React, { useEffect, useRef, useState } from "react";
import { fetchExperienceTripslist } from "../services/ExperienceTripslist";
import { API_BASE } from "../api/apiConfig";

const HomeJourneys = () => {
  const [experts, setExperts] = useState([]);
  const sliderRef = useRef(null);

  useEffect(() => {
    loadExperts();
  }, []);

  const loadExperts = async () => {
    const res = await fetchExperienceTripslist();
    if (res?.status) setExperts(res.data);
  };

  const scroll = (dir) => {
    if (!sliderRef.current) return;
    sliderRef.current.scrollBy({
      left: dir === "left" ? -320 : 320,
      behavior: "smooth",
    });
  };

  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
     <>
<div className="hidden sm:block">
  <section className="relative w-full pt-14 pb-10 md:pt-20 md:pb-14 text-slate-800 bg-gradient-to-b from-amber-50/80 via-orange-50/50 to-white">
    <div className="absolute left-0 top-0 h-64 w-64 rounded-full bg-amber-200/30 blur-3xl" />
    <div className="absolute bottom-0 right-0 h-64 w-64 rounded-full bg-orange-200/30 blur-3xl" />
    <div className="container relative z-10 mx-auto px-4 sm:px-5 md:px-6">
      <div className="mb-6 md:mb-8">
        <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
          <div>
            <div className="mb-2 md:mb-3 inline-flex items-center rounded-full border border-amber-300 bg-amber-100 px-2.5 py-1 text-sm md:text-base font-medium text-amber-700 hover-lift">
              <span className="mr-1.5 h-1.5 w-1.5 rounded-full bg-amber-500 animate-pulse" />
              Learn While You Travel
            </div>
            <h2 className="mb-1.5 md:mb-2 text-xl md:text-2xl font-bold tracking-tight text-slate-900">
              Signature Journeys
            </h2>
            <p className="max-w-[700px] text-sm md:text-base text-slate-600">
              Travel experiences that transform you with new skills and
              perspectives. Learn, grow, and connect while exploring incredible
              destinations.
            </p>
          </div>
          <div className="flex items-center gap-2 text-sm md:text-base font-medium mt-3 md:mt-0">
            <a href="/ExperienceTrips">
              <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md px-3 border-amber-300 bg-white text-amber-700 hover:bg-amber-50">
                View All Journeys
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-chevron-right ml-1 h-4 w-4"
                >
                  <path d="m9 18 6-6-6-6" />
                </svg>
              </button>
            </a>
          </div>
        </div>
      </div>
      
      <div className="relative -mx-4 px-4 sm:-mx-5 sm:px-5 md:-mx-4 md:px-4">
        <button onClick={() => scroll("left")}
          className="absolute -left-1 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md transition-all duration-300 hover:bg-primary/10 hover:text-primary hover:scale-110 md:left-0"
          aria-label="Previous meetups"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-chevron-left h-4 w-4 md:h-5 md:w-5"
          >
            <path d="m15 18-6-6 6-6" />
          </svg>
        </button>
        <div ref={sliderRef}
          className="flex snap-x snap-mandatory gap-3 md:gap-4 overflow-x-auto pb-6 scrollbar-hide experience-trips-container"
          style={{ scrollbarWidth: "none" }}
        >

        {experts.map((expert, index) => (
          <a key={expert.id || index}
            className="group min-w-[300px] max-w-[85vw] md:min-w-[340px] md:max-w-[380px] flex-shrink-0 snap-start block"
            href={`/ExperienceTripsDtl/${expert.id}`}
          >
            <div className="bg-white rounded-3xl overflow-hidden shadow-lg border border-amber-100/50 transition-shadow duration-300 hover:shadow-xl">
              <div className="relative h-[220px] md:h-[260px]">
                <img
                  alt={expert.city}
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover transition-transform duration-700 group-hover:scale-105"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src={`${API_BASE}/${expert.images}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                <div className="absolute top-3 left-3 h-9 w-9 md:h-10 md:w-10 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center shadow-sm">
                  <span className="text-sm md:text-base font-bold text-amber-600">
                    {(index + 1).toString().padStart(2, "0")}
                  </span>
                </div>
                <div className="absolute top-3 right-3 bg-amber-500 px-3 py-1 rounded-full text-xs font-semibold text-white">
                  {expert.no_of_days} Days
                </div>
                <div className="absolute bottom-3 left-3 right-3">
                  <h3 className="font-bold text-white text-base md:text-lg leading-tight line-clamp-2">
                   {expert.name}
                  </h3>
                </div>
              </div>
              <div className="p-4">
                <div className="inline-flex items-center gap-1.5 bg-amber-50 text-amber-700 text-xs font-medium px-2.5 py-1 rounded-full mb-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-zap h-3.5 w-3.5"
                  >
                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
                  </svg>
                  {expert.tage}
                </div>
                <div className="flex items-center gap-4 text-xs text-slate-500 mb-3">
                  <div className="flex items-center gap-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-map-pin h-3.5 w-3.5 text-slate-400"
                    >
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                      <circle cx={12} cy={10} r={3} />
                    </svg>
                    <span>{expert.city}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-calendar h-3.5 w-3.5 text-slate-400"
                    >
                      <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                      <line x1={16} x2={16} y1={2} y2={6} />
                      <line x1={8} x2={8} y1={2} y2={6} />
                      <line x1={3} x2={21} y1={10} y2={10} />
                    </svg>
                    <span>{formatDate(expert.expdate)}</span>
                  </div>
                </div>
                <div className="flex items-center justify-between pt-3 border-t border-slate-100">

              {expert.local_experts_details && expert.local_experts_details.length > 0 && (
                  <div className="flex items-center gap-2">
                    <div className="relative w-8 h-8 md:w-9 md:h-9 rounded-full overflow-hidden ring-2 ring-amber-200">
                      <img
                        alt={expert.local_experts_details[0].name}
                        loading="lazy"
                        decoding="async"
                        data-nimg="fill"
                        className="object-cover"
                        style={{
                          position: "absolute",
                          height: "100%",
                          width: "100%",
                          inset: 0,
                          color: "transparent"
                        }}
                        src={`${API_BASE}/${expert.local_experts_details[0].profile_image}`}
                      />
                    </div>
                    <span className="text-sm font-medium text-slate-700">
                      {expert.local_experts_details[0].name}
                    </span>
                  </div>
               )}
                  <div className="text-right">
                    <p className="text-base font-bold text-slate-900">₹{expert.charges}</p>
                  </div>
                </div>
              </div>
            </div>
          </a>
        ))}

        </div>
        <button onClick={() => scroll("right")}
          className="absolute -right-1 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md transition-all duration-300 hover:bg-primary/10 hover:text-primary hover:scale-110 md:right-0"
          aria-label="Next meetups"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-chevron-right h-4 w-4 md:h-5 md:w-5"
          >
            <path d="m9 18 6-6-6-6" />
          </svg>
        </button>
      </div>
      <div className="mt-2 flex items-center justify-center gap-1 md:hidden">
        <div className="h-1.5 w-8 rounded-full bg-primary/30 animate-pulse-soft" />
        <div
          className="h-1.5 w-4 rounded-full bg-primary/60 animate-pulse-soft"
          style={{ animationDelay: "0.2s" }}
        />
        <div
          className="h-1.5 w-3 rounded-full bg-primary/30 animate-pulse-soft"
          style={{ animationDelay: "0.4s" }}
        />
      </div>
      <div className="mt-8 text-center">
        <a href="/ExperienceTrips">
          <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 py-2 text-sm md:text-base border-primary/30 bg-transparent text-primary hover:bg-primary/10 px-4">
            View All Experiences
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-chevron-right ml-1.5 h-4 w-4 md:h-5 md:w-5"
            >
              <path d="m9 18 6-6-6-6" />
            </svg>
          </button>
        </a>
      </div>
    </div>
  </section>
</div>

<div className="block sm:hidden">
<section className="py-6 bg-gradient-to-b from-amber-50/80 via-orange-50/50 to-white">
  <div className="px-4 mb-5">
    <div className="flex items-center justify-between">
      <div>
        <div className="inline-flex items-center gap-1.5 bg-amber-100 text-amber-700 text-[10px] font-semibold px-2.5 py-1 rounded-full mb-2">
          <span className="h-1.5 w-1.5 rounded-full bg-amber-500 animate-pulse" />
          Learn While You Travel
        </div>
        <h3 className="text-xl font-bold text-slate-900">Signature Journeys</h3>
      </div>
      <a
        className="text-amber-600 text-xs font-semibold flex items-center gap-0.5"
        href="/ExperienceTrips"
      >
        Explore
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-chevron-right h-4 w-4"
        >
          <path d="m9 18 6-6-6-6" />
        </svg>
      </a>
    </div>
  </div>
  <div className="flex gap-4 scrollbar-custom pb-4 px-4">

  {experts.map((expert, index) => (
    <a key={expert.id || index} className="flex-shrink-0" href={`/ExperienceTripsDtl/${expert.id}`}>
      <div className="w-72 bg-white rounded-3xl overflow-hidden shadow-lg border border-amber-100/50">
        <div className="relative h-[240px]">
          <img
            alt={expert.city}
            loading="lazy"
            decoding="async"
            data-nimg="fill"
            className="object-cover"
            style={{
              position: "absolute",
              height: "100%",
              width: "100%",
              inset: 0,
              color: "transparent"
            }}
            src={`${API_BASE}/${expert.images}`}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
          <div className="absolute top-3 left-3 h-8 w-8 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center shadow-sm">
            <span className="text-sm font-bold text-amber-600">{(index + 1).toString().padStart(2, "0")}</span>
          </div>
          <div className="absolute top-3 right-3 bg-amber-500 px-2.5 py-1 rounded-full text-[10px] font-semibold text-white">
            {expert.no_of_days} Days
          </div>
          <div className="absolute bottom-3 left-3 right-3">
            <h4 className="font-bold text-white text-sm leading-tight line-clamp-2">
              {expert.name}
            </h4>
          </div>
        </div>
        <div className="p-3.5">
          <div className="inline-flex items-center gap-1.5 bg-amber-50 text-amber-700 text-[10px] font-medium px-2 py-1 rounded-full mb-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-zap h-3 w-3"
            >
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
            </svg>
            {expert.tage}
          </div>
          <div className="flex items-center gap-3 text-[11px] text-slate-500 mb-3">
            <div className="flex items-center gap-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-map-pin h-3 w-3 text-slate-400"
              >
                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                <circle cx={12} cy={10} r={3} />
              </svg>
              <span>{expert.city}</span>
            </div>
            <div className="flex items-center gap-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-calendar h-3 w-3 text-slate-400"
              >
                <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                <line x1={16} x2={16} y1={2} y2={6} />
                <line x1={8} x2={8} y1={2} y2={6} />
                <line x1={3} x2={21} y1={10} y2={10} />
              </svg>
              <span>{formatDate(expert.expdate)}</span>
            </div>
          </div>
          <div className="flex items-center justify-between pt-3 border-t border-slate-100">

          {expert.local_experts_details && expert.local_experts_details.length > 0 && (
            <div className="flex items-center gap-2">
              <div className="relative w-7 h-7 rounded-full overflow-hidden ring-2 ring-amber-200">
                <img
                  alt={expert.local_experts_details[0].name}
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                  }}
                  src={`${API_BASE}/${expert.local_experts_details[0].profile_image}`}
                />
              </div>
              <span className="text-xs font-medium text-slate-700">
                {expert.local_experts_details[0].name}
              </span>
            </div>
          )}
          
            <div className="text-right">
              <p className="text-sm font-bold text-slate-900">₹{expert.charges}</p>
            </div>
          </div>
        </div>
      </div>
    </a>
  ))}

  </div>
</section>
</div>

</>
);

};

export default HomeJourneys;
